import { on, Action } from '@ngrx/store';
import { createImmerReducer } from 'ngrx-immer/store';
import * as JobseekerActions from './actions';
import { SpecializationState } from './state';

const initialState: SpecializationState = {
  specializations: [],
  loading: false,
};

const reducer = createImmerReducer(
  initialState,
  on(JobseekerActions.getJobseekerSpecializationList, (state) => {
    state.loading = true;

    return state;
  }),

  on(
    JobseekerActions.getJobseekerSpecializationListSuccess,
    (state, { payload }) => {
      state.specializations = payload;
      state.loading = false;

      return state;
    }
  ),

  on(
    JobseekerActions.getJobseekerSpecializationListFail,
    (state, { payload }) => {
      state.loading = false;

      return state;
    }
  )
);

export function specializationReducer(
  state: SpecializationState | undefined,
  action: Action
) {
  return reducer(state, action);
}
